export default __webpack_public_path__ + "static/media/memcached.2dbd018e.svg";